import createQueue from 'async/queue';
import { sendCommerce } from '@gandi/tracking';
import { selectCountItems } from '../components/CartWidget/modules/selectors';
import { addProduct, addProducts, addProductOptimistic, addProductSuccess, removeProductSuccess, addBundleSuccess, removeProduct, removeProducts, removeBundle } from '../modules/actions';
import { selectCartIsActive, selectProducts, selectCartTotal, selectCartUUID, selectCartCurrency, selectCountTotalProducts } from '../modules/selectors';
import { resource as suggestionResource } from '../modules/suggest/actions';
import { ensureWeHaveACart, deleteCartIfEmpty, cleanCorporateProducts, cleanMarketplaceProducts } from './helpers';
const addActions = [addProduct, addProducts, addProductOptimistic];
const deleteActions = [removeProduct, removeProducts, removeBundle];
const suggestActions = [addProductSuccess, removeProductSuccess, addBundleSuccess];
export const cartMiddleware = store => next => {
  const {
    dispatch,
    getState
  } = store;
  const hasActiveCart = selectCartIsActive(getState());
  const queue = createQueue((task, callback) => {
    let taskPayload = task.payload[0];
    if (addActions.includes(task.meta.action) && !hasActiveCart) {
      taskPayload = {
        ...taskPayload,
        options: {
          ...taskPayload.options,
          isProductCartCreation: true
        }
      };
    }
    return dispatch(task.meta.action(taskPayload)).then(resp => callback(null, resp), err => callback(err)).catch(err => callback(err));
  });
  return action => {
    if (!action.meta || !action.meta.cart) {
      return next(action);
    }
    const payload = action.payload;
    if (!selectCartIsActive(getState()) && !queue.paused) {
      queue.pause();
      dispatch(ensureWeHaveACart(payload.cartId)).then(() => {
        queue.resume();
      }, err => {
        queue.resume();
        throw err;
      });
    }
    return new Promise((resolve, reject) => {
      queue.push(action, (err, resp) => {
        if (err) reject(err);
        const addition = addActions.includes(action.meta.action);
        const deletion = deleteActions.includes(action.meta.action);
        const suggestion = suggestActions.includes(action.meta.action);
        const productsToDelete = selectProducts(getState()).filter(product => Array.from(payload).includes(product.id));
        const cartId = selectCartUUID(getState());
        const cartTotal = selectCartTotal(getState());
        const currency = selectCartCurrency(getState());
        Promise.resolve().then(() => deletion && dispatch(cleanCorporateProducts())).then(() => suggestion && dispatch(suggestionResource.invalidate())).then(() => deletion && dispatch(cleanMarketplaceProducts(productsToDelete))).then(() => deletion && dispatch(deleteCartIfEmpty())).then(() => (addition || deletion || suggestion) && sendCommerce({
          name: 'cart.update',
          data: {
            cart_id: cartId,
            cart_currency: currency,
            cart_turnovertaxincluded: cartTotal.afterTaxes,
            cart_turnovertaxfree: cartTotal.beforeTaxes,
            cart_quantity: selectCountTotalProducts(getState()),
            cart_nbdistinctproduct: selectCountItems(getState())
          }
        })).then(() => resolve(resp), () => resolve(resp));
      });
    });
  };
};